<template>
  <BlokkliProvider
    v-if="variation"
    v-bind="variation.blokkliProps"
    class="container"
  >
    <PDPStage
      :tagline="$texts('loveItem', 'Love item')"
      :cta-button="variation.ctaType"
      :available-sizes="sizes"
      :variation="variation"
    />
    <BlokkliField
      class="mt-64 gap-64"
      name="field_paragraphs"
      :list="paragraphs"
    />
    <RenderCacheable
      v-if="infoParagraphs"
      :cache-key="cacheKey"
      :max-age="60 * 60"
    >
      <PDPInfoGrid :paragraphs="infoParagraphs" />
    </RenderCacheable>
    <PDPCommerceInfo class="mt-[--paragraph-gap-desktop]" />
  </BlokkliProvider>
</template>

<script lang="ts" setup>
import { falsy } from '~/helpers/type'

/**
 * The PDP component for any other product types.
 */
definePageMeta({
  name: 'product-detail-generic',
  path: '/:prefix/product/:type(gift|giveaway|tool|spare-part)/:name/:sku',
})

const { $texts } = useEasyTexts()

const route = useRoute()
const { variations, variation, paragraphs } = await useProductRoute(
  'type',
  route,
)

const sizes = computed(() => {
  return variations.value
    .map((variation) => {
      const label = ('size' in variation && variation.size) ?? variation.title
      const value = variation?.url?.path

      if (label && value) {
        return { value, label }
      } else {
        return undefined
      }
    })
    .filter(falsy)
})

const { data: infoParagraphs } = await useAsyncData(() =>
  useCachedGraphqlQuery('infoParagraphsStrap').then(
    (v) => v.data.config?.paragraphs || [],
  ),
)

const cacheKey = useCacheKey('strap-info-grid')

const { trackPageView } = useAnalyticsTracking()
trackPageView()
</script>

<style lang="scss" scoped>
:deep(.paragraph),
.paragraph {
  &:first-of-type {
    @include pdp-first-paragraph-spacing;
  }

  @include paragraph-spacing;
}
</style>
